import { Component, OnInit, Renderer2, Inject } from '@angular/core';
import { AppSettingsService } from 't4-app-integration';
import { LayoutService } from 'app-components';


@Component({
    selector: 'app-chatbot',
    templateUrl: './chatbot.component.html',
    styleUrls: ['./chatbot.component.css'],
    standalone: false
})
export class ChatbotComponent implements OnInit {
  zendeskKey = 'fa045ccb-5bab-4193-bff5-7ec511bf2836';
  lang = 'sv';

  constructor(private renderer: Renderer2, public appSettings: AppSettingsService, private layout: LayoutService) { }

  ngOnInit(): void {
    if (this.appSettings.appType == 'app' && this.appSettings.contextId.toLowerCase() == 'kanleiesunmanned_api') {
      setTimeout(() => {
        this.loadZendeskScript();
        setInterval(() => {
          var va = document.getElementsByTagName("view-actions");
          var menu = document.getElementsByClassName("menu-container");
          var body = document.getElementsByTagName("body");
          var changed = false;

          if (menu.length > 0) {
            // Green
            (window as any).zE('webWidget', 'updateSettings', { webWidget: { color: { launcher: '#4fb25b' } } });
            changed = true;
          } else if (va.length > 0 && va[0].getAttribute('mode') == "white") {
            // Green
            (window as any).zE('webWidget', 'updateSettings', { webWidget: { color: { launcher: '#4fb25b' } } });
            changed = true;
          } else if (va.length > 0 && va[0].getAttribute('mode') != "white") {
            // White
            (window as any).zE('webWidget', 'updateSettings', { webWidget: { color: { launcher: '#FFFFFF' } } });
            changed = true;
          } else {
            for (var i = 0; i < body.length; i++) {
              if (body[i].className.indexOf('primary')) {
                // White 
                (window as any).zE('webWidget', 'updateSettings', { webWidget: { color: { launcher: '#FFFFFF' } } });
                changed = true;
              }
            }
          }
          
          // Green
          if (!changed)
            (window as any).zE('webWidget', 'updateSettings', { webWidget: { color: { launcher: '#4fb25b' } } });
        }, 100);
      }, 2000);
    }
  }

  loadZendeskScript(): void {
    const script = this.renderer.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.id = 'ze-snippet';
    script.charset = 'utf-8';
    script.src = `https://static.zdassets.com/ekr/snippet.js?key=${this.zendeskKey}`;
    script.onload = () => {
        (window as any).zE('webWidget', 'setLocale', this.appSettings.getLanguage());
    };

    script.onerror = (error) => { console.error('Error loading the zendesk script:', error); };

    this.renderer.appendChild(document.head, script);
  }
}
